import { render } from "./form_4.vue?vue&type=template&id=fe32818a"
import script from "./form_4.vue?vue&type=script&lang=js"
export * from "./form_4.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe32818a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe32818a', __exports__)) {
    console.log('reload')
    api.reload('fe32818a', __exports__)
  }
  
  module.hot.accept("./form_4.vue?vue&type=template&id=fe32818a", () => {
    console.log('re-render')
    api.rerender('fe32818a', render)
  })

}


export default __exports__